import { useTranslation } from 'react-i18next'

import { Alert, Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteDeliveryMethodModal = ({ show, onClose, onDelete, deliveryMethod }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Eliminar método de devolución')} size="m">
      <Styles.Container>
        <Styles.Text>{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Styles.Text>
        {deliveryMethod?.carrier?.is_connected && (
          <Alert type="warning">
            {t(
              'Este método tiene activada la conexión con el transportista para la creación automática de etiquetas de envio.'
            )}
          </Alert>
        )}
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteDeliveryMethodModal
